import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';

import { ComponentsModule } from '@app/components/components.module';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { DatePickerDeviceComponent } from './date-picker-device/date-picker-device.component';
import { CustomDateAdapter } from './date-picker-material/custom-date-adapter';
import { DatePickerHeaderComponent } from './date-picker-material/date-picker-header/date-picker-header.component';
import { DatePickerMaterialComponent } from './date-picker-material/date-picker-material.component';
import { DatePickerComponent } from './date-picker.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule.forChild(),
    ComponentsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule
  ],
  declarations: [
    DatePickerComponent,
    DatePickerMaterialComponent,
    DatePickerDeviceComponent,
    DatePickerHeaderComponent
  ],
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapter }],
  exports: [DatePickerComponent, DatePickerDeviceComponent],
  entryComponents: [DatePickerHeaderComponent]
})
export class DatePickerModule {}
